module.exports = __webpack_public_path__ + "img/poster.e8c2c6cc.jpg";